export default "__VITE_ASSET__2lLIoenn__"